// extracted by mini-css-extract-plugin
module.exports = {"savedSearch":"CQ","m-heart-pulse":"DQ","heartActive":"EQ","m-heart-activate":"FQ"};